import React from 'react';
import { makeStyles } from '@material-ui/core';
import MainLayoutTopBar from './MainLayoutTopBar';
import { Switch, Route } from 'react-router-dom';
import { routes } from 'src/routesService';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    display: 'flex',
    height: '100%',
    overflow: 'hidden',
    width: '100%'
  },
  wrapper: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

const MainLayout = (props) => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <MainLayoutTopBar />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>
            <Switch>
              {
                Object.keys(routes).map((key, index) => {
                  return (
                    <Route key={index} path={`${routes[key].path}`} component={routes[key].element} exact />
                  )
                })
              }
            </Switch>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
